import React from 'react';
import PropTypes from 'prop-types';
import {Toaster} from '@learningblocks/storybook-components';
import {useMicrocentrifuge} from './Microcentrifuge.utils';
import {Microcentrifuge as Component} from './Microcentrifuge';
import './style.scss';

export let CentrifugeContext = React.createContext();
/**
 * Microcentrifuge:
 *  - Lab apparatus Microcentrifuge
 */
export function Microcentrifuge(props) {
  const toastAlert = React.useContext(Toaster.Context);

  return (
    <CentrifugeContext.Provider value={useMicrocentrifuge(props, toastAlert)}>
      {React.createElement(Component, props)}
    </CentrifugeContext.Provider>
  );
}

Microcentrifuge.propTypes = Component.propTypes;

Microcentrifuge.defaultProps = Component.defaultProps;
